import styled from 'styled-components'
import COLORS from '@colors'

export const Main = styled.div`
  font-family: 'Barlow';
  font-size: 14px;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
`

export const Body = styled.div`
  position: absolute;
  height: calc(100% - 64px);
  width: 100%;
  top: 64px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
`

export const CalendarContainer = styled.div`
  position: relative;
  height: 200px;
  background: ${COLORS.whiteF3O49} 0% 0% no-repeat padding-box;
`

export const ListContainer = styled.div`
  height: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FiltersContainer = styled.div`
  background: ${COLORS.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 3;
  top: -27.5px;
  outline: 0;
  border: 0;
  height: 55px;
  width: 53%;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1366px) {
    width: 80%;
  }
`
export const List = styled.div`
  width: 44%;
  @media (max-width: 1366px) {
    width: 66%;
  }
`

export const SortWrapper = styled.div`
  width: 20%;
  cursor: pointer;
  height: 55px;
  position: relative;
  font: 500 14px/28px Barlow;
  color: ${COLORS.leather};
  border-left: 1px solid ${COLORS.grayE1};
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 10px;
  padding-right: 25px;
  text-align: center;
`

export const IconWrapper = styled.div`
  ${({ alignRight }) =>
    alignRight
      ? `
    right:15px
    top: 15px;
    `
      : `
      left:10px
      top: 10px;
    `}
  position: absolute;
`
